// //mobile/burger nav
// jQuery(".hamburger").on("click", function () {
//   console.log("... you want fries with that?");
//   $(this).toggleClass("is-active");
//   $(".mobile-menu,.burger-menu").toggleClass("is-active");
//   //reset all menu positions...
//   $(".menu,.sub-menu").removeClass("inactive is-active");
// });

// jQuery(".header").on("click", ".burger-menu.is-active", function () {
//   $(this).removeClass("is-active");
//   $(".burger-nav .hamburger").removeClass("is-active");
// });

// jQuery(".burger-menu a").on("click", function (e) {
//   e.stopPropagation();
// });

// //make sub-menus more accessible by adding an id for aria-controls
// jQuery(".burger-menu .menu-item-has-children").each(function () {
//   var newid = "sub-" + $(this).attr("id");
//   $(this).find(".sub-menu").attr("id", newid); //! is this recursive to lower levels?
// });

// //activate burger sub-menu
// var $subMenuControl = jQuery(
//   "<button class='sub-menu-control' aria-label='Sub-menu'>Hide/Show</button>"
// );
// $subMenuControl.on("click", function (e) {
//   e.preventDefault();
//   e.stopPropagation();
//   $(this).parents(".menu-item-has-children").toggleClass("sub-menu-active");
// });

// jQuery(".burger-menu .menu-item-has-children > a").after($subMenuControl);
// // $(".burger-menu .menu-item-has-children > a").append($subMenuControl).on("focus",function(){
// //     console.log("Menu focus is ",$(this));
// //     $(this).parents(".menu-item-has-children").toggleClass("sub-menu-active");
// // }).on("blur",function(){
// //     console.log("Focus exit, but don't close menu as sub-items need to be accessible");
// // });

// jQuery(".menu .sub-menu").addClass("l1");
// jQuery(".menu .sub-menu .sub-menu").addClass("l2").removeClass("l1");
// jQuery(".menu .sub-menu .sub-menu .sub-menu").addClass("l3").removeClass("l2");

// jQuery(".mobile-nav .menu-item-has-children").append(
//   "<i class='open'> &#10095; </i>"
// );
// jQuery(".mobile-nav .menu-item-has-children .sub-menu").prepend(
//   "<li class='close'> &#10094; Back </li>"
// );

// jQuery(".mobile-nav a[href*='#']").on("click", function () {
//   console.log("Mobile nav hash link clicked...");
//   $(this).parents(".menu").removeClass("inactive");
//   $(this).parents("li").find(".sub-menu").removeClass("is-active");
//   $(".mobile-menu.is-active,.mobile-nav .hamburger").removeClass("is-active");
// });

// jQuery(".menu-item-has-children").on("click", ".open", function (e) {
//   // console.log("reveal sub menu");
//   e.stopPropagation();
//   $(this).parents(".menu,.sub-menu").addClass("inactive");
//   $(this).parents("li").find("> .sub-menu").addClass("is-active");
// });

// jQuery(".sub-menu.l1").on("click", ".close", function (e) {
//   //console.log("close sub menu l1");
//   e.stopPropagation();
//   $(this).parents(".menu").removeClass("inactive");
//   $(this).parents("li").find(".sub-menu.l1").removeClass("is-active");
// });

// jQuery(".sub-menu.l2").on("click", ".close", function (e) {
//   //console.log("close sub menu l2");
//   e.stopPropagation();

//   $(this).parents(".l1").removeClass("inactive");
//   $(this).parents("li").find(".sub-menu.l2").removeClass("is-active");
// });

// //expeandable column for mobile
// jQuery(".colExpand").on("click", function (e) {
//   $(this).toggleClass("active");
// });

// // no link links
// jQuery('.no-link,.no-link > a,.menu-item-has-children > a[href="#"]').on(
//   "click",
//   function (x) {
//     x.preventDefault();
//   }
// );
